require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/object/assign.js
// module id = 943
// module chunks = 48 49 50